import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../../../../_metronic/_partials/controls";
import { currencyFormatter } from "../../../pickup/pickup-detail/pickup-detail-table/column-formatters";

export default function SummaryTable({ data }) {
  // console.log("data", data);
  // Table columns
  const columns = [
    {
      dataField: "total_donation_payment",
      text: "Pembayaran Donasi",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
    {
      dataField: "total_bank_statement.amount",
      text: "Transaksi Bank",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
    {
      dataField: "diff",
      text: "Biaya Transaksi",
      formatter: (cell) => {
        return currencyFormatter(Math.abs(cell));
      },
      classes: "text-right",
      headerClasses: "text-right",
    },
  ];

  return (
    <>
      <BootstrapTable
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        remote
        keyField="uuid"
        data={data}
        columns={columns}
      />
    </>
  );
}
